import React from 'react';
import { motion } from 'framer-motion';
const CHECKOUT_URL = 'https://gripdominante.myshopify.com/cart/46674134270141:1?checkout';
interface ButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'outline';
  size?: 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  className?: string;
  href?: string;
}
export function Button({
  children,
  variant = 'primary',
  size = 'lg',
  fullWidth = false,
  className = '',
  href = CHECKOUT_URL
}: ButtonProps) {
  const baseStyles = 'relative font-oswald uppercase tracking-wider font-bold transition-all duration-300 flex items-center justify-center group overflow-hidden mx-auto no-underline cursor-pointer';
  const variants = {
    primary: 'bg-neon-cyan text-dark-900 hover:bg-white shadow-neon-cyan hover:shadow-neon-cyan-strong',
    outline: 'bg-transparent border-2 border-neon-cyan text-neon-cyan hover:bg-neon-cyan hover:text-dark-900 shadow-[inset_0_0_10px_rgba(0,240,255,0.2)] hover:shadow-neon-cyan'
  };
  const sizes = {
    md: 'px-6 py-3 text-lg',
    lg: 'px-8 py-4 text-xl',
    xl: 'px-10 py-5 text-2xl'
  };
  const width = fullWidth ? 'w-full' : '';
  return <motion.a href={href} target="_blank" rel="noopener noreferrer" whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${width} ${className}`} data-id="element-38">
      {/* Shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/40 to-transparent group-hover:animate-[shimmer_1.5s_infinite] skew-x-12" data-id="element-39" />
      <span className="relative z-10 flex items-center gap-2" data-id="element-40">{children}</span>
    </motion.a>;
}